function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "35px",
    height: "35px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "symbol",
    id: "printer",
    d: "M44.12,40.151l-24,0l0,12l24,0l0,-12Zm-28,-12.002c-0.663,0.001 -1.325,0.002 -1.988,0.002c-1.051,0.007 -1.978,0.902 -2.012,1.949c-0.078,4.052 -0.176,8.109 0.003,12.158c0.057,1.007 0.952,1.873 1.97,1.893c0.676,0.004 1.351,0.01 2.027,0.016l0,-8.016l32,0l0,8.082c0.709,-0.025 1.419,-0.053 2.129,-0.085c1.007,-0.057 1.875,-0.954 1.894,-1.97c0.027,-4.044 0.175,-8.092 -0.003,-12.132c-0.058,-1.002 -0.939,-1.862 -1.944,-1.894c-0.692,-0.013 -1.384,-0.025 -2.076,-0.035l0,0.046l-32,0l0,-0.014Zm28,-15.986l-24,0l0,11.904c7.999,-0.075 16,-0.017 24,0.042l0,-11.946Zm-28,43.988l0,-7.963c-0.719,-0.012 -1.437,-0.025 -2.155,-0.039c-3.05,-0.097 -5.746,-2.771 -5.843,-5.843c-0.078,-4.102 -0.078,-8.207 0,-12.31c0.096,-3.044 2.77,-5.745 5.843,-5.843c0.718,-0.014 1.436,-0.026 2.155,-0.037l0,-15.953l32,0l0,15.975c0.7,0.005 1.4,0.009 2.1,0.014c3.094,0.059 5.863,2.783 5.922,5.922c0.026,4.077 0.076,8.155 -0.001,12.232c-0.097,3.044 -2.771,5.746 -5.843,5.843c-0.726,0.014 -1.452,0.027 -2.178,0.039l0,7.963l-32,0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrinter);
export default __webpack_public_path__ + "static/media/ico-printer.8e604a06b177b007fda9b5dff050e1b7.svg";
export { ForwardRef as ReactComponent };